<template>
	<div class="container page">
		<van-nav-bar :title="$t('my.task_record')" class="nav-bar">
			<template #left>
				<van-icon name="arrow-left" color="#fff" @click="back()" />
			</template>
		</van-nav-bar>

		<div class="main">
			<van-pull-refresh v-model="isLoading" @refresh="onRefresh">
				<van-empty v-if="!fetching && displayList.length === 0" :description="$t('withdraw.empty_data')" />
				<van-list
					v-else
					v-model="loadingMore"
					:finished="finished"
					:finished-text="displayList.length ? ' ' : ''"
					:immediate-check="false"
					@load="loadMore"
				>
					<div class="item_list" v-for="v in displayList" :key="v._key">
						<div class="lottery_info">
							<img class="cover" :src="v.ico" alt="" loading="lazy" />
							<span class="period-number">{{v.expect}}</span>
							<span class="period-number">{{v.name}}</span>
						</div>
						<div class="recent">
							<div class="kuaisan-ball left">
								<div>
									<span>{{$t("reservation.result")}}</span>
									<span class="ressquareBox">{{ v.size }}</span>
									<span class="ressquareBox">{{ v.double }}</span>
								</div>
							</div>
						</div>

						<div class="topInfo bet-row">
							<span>{{$t("reservation.curr_choose")}}：{{ v.betLabel }}</span>
						</div>

						<div class="topInfo">
							<span v-if="v.status === 1" style="color: #07c160">{{v.status_text}}</span>
							<span v-else>{{v.status_text}}</span>
							<span>{{$t("reservation.money")}}：{{v.money}}</span>
						</div>
						<div class="topInfo" v-if="v.pnlText">
							<span :class="v.pnl < 0 ? 'pnl-lose' : 'pnl-win'">
								{{$t("reservation.win_lose")}}：{{ v.pnlText }}
							</span>
						</div>
						<div class="time">
							<span>{{$t("reservation.order_time")}}：{{v.create_time}}</span>
						</div>
						<div class="time">
							<span>{{$t("reservation.settle_time")}}：{{v.update_time}}</span>
						</div>
						<div class="time countdown-row" v-if="v.countdownMs > 0">
							<span>{{$t("reservation.settle_countdown")}}：</span>
							<van-count-down
								:key="'cd_' + v._key + '_' + v.countdownMs"
								:time="v.countdownMs"
								format="mm:ss"
								@finish="onCountdownFinish"
							/>
						</div>
					</div>
				</van-list>
			</van-pull-refresh>
		</div>
	</div>
</template>

<script>
	const PAGE_SIZE = 20;

	export default {
		data() {
			return {
				isLoading: false,
				fetching: false,
				loadingMore: false,
				finished: false,
				allList: [],
				displayList: [],
				page: 0,
			};
		},
		methods: {
			back() {
				return window.history.back();
			},
			onRefresh() {
				this.getUserGameList(true).finally(() => {
					this.isLoading = false;
					this.$toast(this.$t("reservation.refresh"));
				});
			},
			getLangLabels(lang) {
				if (lang === 'zh') {
					return { rose: '玫瑰', lily: '百合', balloon: '氣球', fireworks: '煙花' };
				}
				if (lang === 'en') {
					return { rose: 'Rose', lily: 'Lily', balloon: 'Balloon', fireworks: 'Fireworks' };
				}
				if (lang === 'ja') {
					return { rose: 'バラ', lily: 'リリー', balloon: '気球', fireworks: '花火' };
				}
				if (lang === 'es') {
					return { rose: 'Rosa', lily: 'Lirio', balloon: 'Globo', fireworks: 'Fuegos' };
				}
				return { rose: '청순한', lily: '섹시한', balloon: '패티쉬', fireworks: '귀여운' };
			},
			/** 解析开奖号；未开奖返回 null（不要补 0） */
			parseOpenCodes(opencode) {
				if (opencode == null || opencode === '' || opencode === '--') return null;

				let codes;
				if (Array.isArray(opencode)) {
					codes = opencode.map((n) => Number(n));
				} else if (typeof opencode === 'string') {
					const s = opencode.trim();
					if (!s) return null;
					codes = s.split(/[,|]/).map((n) => Number(n));
				} else {
					return null;
				}

				if (codes.length < 3 || codes.some((n) => Number.isNaN(n))) return null;
				// 骰子合法范围合计至少 3；全 0 视为未开奖占位
				if (codes.every((n) => n === 0)) return null;
				return codes;
			},
			mapBetType(t, labels) {
				const key = String(t || '').trim().toLowerCase();
				if (!key) return '';
				if (key === 'big' || key === 'da') return labels.rose;
				if (key === 'small' || key === 'xiao') return labels.lily;
				if (key === 'one' || key === 'single' || key === 'odd') return labels.fireworks;
				if (key === 'two' || key === 'double' || key === 'even') return labels.balloon;
				return String(t);
			},
			/** 投注选项：后台同期待注合并在 data[] / types[] 里，字段为 type */
			formatBetLabel(item, labels) {
				const parts = [];
				const pushRaw = (raw) => {
					String(raw || '').split(',').forEach((t) => {
						const label = this.mapBetType(t, labels);
						if (label) parts.push(label);
					});
				};

				if (Array.isArray(item.types) && item.types.length) {
					item.types.forEach((t) => pushRaw(t));
				} else if (Array.isArray(item.data) && item.data.length) {
					item.data.forEach((row) => pushRaw(row.type));
				} else {
					pushRaw(item.type);
				}

				// 去重保序
				const seen = new Set();
				const uniq = [];
				parts.forEach((p) => {
					if (!seen.has(p)) {
						seen.add(p);
						uniq.push(p);
					}
				});
				return uniq.length ? uniq.join(' / ') : '--';
			},
			/** 未结算：按彩种周期 rule(分钟) 对齐到下一期结束的倒计时 */
			calcCountdownMs(item) {
				if (Number(item.status) === 1) return 0;
				const row = Array.isArray(item.data) && item.data.length ? item.data[0] : item;
				const ruleMin = Number((row.lottery && row.lottery.rule) || item.rule || 3) || 3;
				const ruleSec = Math.max(60, ruleMin * 60);
				const now = new Date();
				const daySec = now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds();
				let remain = ruleSec - (daySec % ruleSec);
				if (remain <= 0) remain = ruleSec;
				return remain * 1000;
			},
			onCountdownFinish() {
				// 倒计时结束刷新列表，拿最新结算状态
				this.getUserGameList(true);
			},
			/** 结算后输赢：赢=正数(下单积分)，输=负数红色 */
			calcPnl(item) {
				const rows = Array.isArray(item.data) && item.data.length ? item.data : [item];
				let pnl = 0;
				let hasSettled = false;

				rows.forEach((row) => {
					const money = Number(row.money) || 0;
					const isWin = Number(row.is_win);
					if (isWin === 1) {
						hasSettled = true;
						pnl += money;
					} else if (isWin === 2) {
						hasSettled = true;
						pnl -= money;
					}
				});

				if (!hasSettled && Number(item.status) !== 1) {
					return { pnl: null, pnlText: '' };
				}
				if (!hasSettled) {
					return { pnl: null, pnlText: '' };
				}

				const abs = Math.abs(pnl).toFixed(2);
				const pnlText = pnl < 0 ? `-${abs}` : abs;
				return { pnl, pnlText };
			},
			formatItem(item, lang) {
				const labels = this.getLangLabels(lang);
				// 未结算 status=0 或没有 opencode → 一律 --
				const settled = Number(item.status) === 1;
				const codes = settled ? this.parseOpenCodes(item.opencode) : null;

				let size = '--';
				let double = '--';
				let sum = null;

				if (codes) {
					sum = codes[0] + codes[1] + codes[2];
					if (sum >= 11 && sum <= 18) {
						size = labels.rose;
					} else if (sum >= 3 && sum <= 10) {
						size = labels.lily;
					}
					double = (sum % 2 === 0) ? labels.balloon : labels.fireworks;
				}

				const { pnl, pnlText } = this.calcPnl(item);
				const countdownMs = settled ? 0 : this.calcCountdownMs(item);

				return {
					...item,
					_key: item.id != null ? `g_${item.id}_${item.expect}` : `${item.expect}_${item.create_time}_${item.money}`,
					sum,
					size,
					double,
					betLabel: this.formatBetLabel(item, labels),
					status_text: item.status_text || (settled ? '' : (item.update_time || '')),
					pnl,
					pnlText,
					countdownMs,
				};
			},
			resetPaging() {
				this.page = 0;
				this.displayList = [];
				this.finished = false;
				this.loadingMore = false;
			},
			loadMore() {
				if (this.finished || !this.allList.length) {
					this.loadingMore = false;
					this.finished = true;
					return;
				}
				const start = this.page * PAGE_SIZE;
				const next = this.allList.slice(start, start + PAGE_SIZE);
				this.displayList = this.displayList.concat(next);
				this.page += 1;
				this.loadingMore = false;
				if (this.displayList.length >= this.allList.length) {
					this.finished = true;
				}
			},
			getUserGameList(isRefresh = false) {
				this.fetching = true;
				return this.$http({
					method: 'get',
					url: 'user_get_game_list'
				}).then(res => {
					if (res.code !== 200) {
						this.$toast(res.msg || 'error');
						this.allList = [];
						this.resetPaging();
						this.finished = true;
						return;
					}

					const lang = localStorage.getItem('lang') || 'kr';
					// 后台 arraySort 可能仍带字符串 key，json 会变成对象
					let list = [];
					if (Array.isArray(res.data)) {
						list = res.data;
					} else if (res.data && typeof res.data === 'object') {
						list = Object.keys(res.data)
							.sort((a, b) => {
								const ida = Number((res.data[a] && res.data[a].id) || 0);
								const idb = Number((res.data[b] && res.data[b].id) || 0);
								return idb - ida;
							})
							.map((k) => res.data[k]);
					}

					// 一次 map，分页只切数组，避免反复重算
					this.allList = list.map((item) => this.formatItem(item, lang));
					this.resetPaging();
					this.loadMore();
				}).catch(() => {
					this.allList = [];
					this.resetPaging();
					this.finished = true;
				}).finally(() => {
					this.fetching = false;
					if (isRefresh) {
						this.isLoading = false;
					}
				});
			},
		},
		created() {
			if (!localStorage.getItem('token')) {
				this.$router.push({
					path: '/Login'
				})
			} else {
				this.getUserGameList();
			}
		},
	};
</script>

<style lang='less' scoped>
	@import "../../assets/css/base.css";

	::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
		color: #000000;
		font-size: 35px;
	}

	::v-deep .van-loading__text {
		color: #000000;
		font-size: 35px;
	}

	.container .main {
		position: relative;
		overflow: auto;
		background-color: #f2f2f5;
		height: 100%;
		padding: 0 10px;
		-webkit-overflow-scrolling: touch;
	}

	.item_list {
		padding: 20px 22px;
		margin: 24px 12px;
		background: #fff;
		border-radius: 16px;
		line-height: 60px;
		box-shadow: 0 10px 28px rgba(79, 43, 138, 0.22), 0 4px 12px rgba(0, 0, 0, 0.12);
	}

	.item_list .topInfo span {
		flex: 1;
		font-size: 32px;
		font-weight: 700;
		color: #000;
	}

	.item_list .bet-row span {
		font-size: 30px;
		font-weight: 600;
		color: #4f2b8a;
	}

	.item_list .pnl-lose {
		color: #ee0a24 !important;
		font-weight: 700;
	}

	.item_list .pnl-win {
		color: #07c160 !important;
		font-weight: 700;
	}

	.countdown-row {
		display: flex;
		align-items: center;
		gap: 8px;
	}

	.countdown-row ::v-deep .van-count-down {
		color: #d63f8c;
		font-size: 28px;
		font-weight: 700;
	}

	.item_list .time span {
		flex: 1;
		font-size: 25px;
		font-weight: 500;
		color: #000;
	}

	.item_list .desc span {
		font-size: 25px;
		font-weight: 700;
		color: #9b9b9b;
	}

	.item_list .cover {
		width: 60px;
		height: 60px;
		object-fit: cover;
		border-radius: 8px;
		flex-shrink: 0;
	}

	.item_list .period-number {
		margin-left: 50px;
		margin-right: 10px;
		height: 50px;
		line-height: 60px;
		font-size: 35px;
		font-weight: 700;
		color: #000;
	}

	.item_list .lottery_info {
		display: flex;
		align-items: center;
	}

	.recent {
		display: flex;
		align-items: center;
		height: 100px;
	}

	.kuaisan-ball .left {
		justify-content: flex-start;
	}

	.kuaisan-ball {
		flex: 1;
		display: flex;
		align-items: center;
	}

	.ressquareBox {
		background: linear-gradient(90deg, #f560cd, #4f2b8a);
		color: #fff;
		height: 7vw;
		line-height: 7vw;
		text-align: center;
		font-size: 3vw;
		font-weight: 700;
		border-radius: 16px;
		margin-left: 20px;
		padding: 13px 40px;
		min-width: 13vw;
	}
</style>
